import React, { useState } from "react";
import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Card,
  DatePicker,
  Select,
  Upload,
  message,
  Spin,
  Skeleton,
  Table,
  Divider,
  Tag,
} from "antd";
import Icon, { ArrowLeftOutlined, InfoCircleFilled } from "@ant-design/icons";
import IntlMessages from "../util/IntlMessages";
import UploadOutlined from "@ant-design/icons/lib/icons/UploadOutlined";
import ds from "../Services/DataServices";
import { BEHAVIOUR_TYPE } from "../Services/DataServices";
import { IntlProvider } from "react-intl";
import { useHistory } from "react-router-dom";
import { useDispatch, useStore } from "react-redux";
import { userLogOut } from "../appRedux/actions/Auth";
import { getEncryptedID, notAllowMsgCheck, StringIsNullOrEmpty } from "../appRedux/actions";
import InventoryMovementListing from "./InventoryMovementListing";
import ProductImg from "../../src/assets/images/product-details.png";

const ProductDetail = ({ match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useStore();
  const [form] = Form.useForm();
  const [getOutletData, setOutletData] = React.useState([]);
  const [getCustomersData, setCustomersData] = React.useState([]);
  const [isSpinningLoading, setSpinningLoading] = React.useState(true);
  const [isTableLoading, setTableLoading] = React.useState(false);
  const [getProdName, setProdName] = React.useState("");
  const [getProdDesc, setProdDesc] = React.useState("");
  const [getBrandName, setBrandName] = React.useState("");
  const [getProdTags, setProdTags] = React.useState([]);
  const [getProdInventType, setProdInventType] = React.useState("");
  const [getIsCustomSKU, setIsCustomSKU] = React.useState(false);
  const [getCustomSKUCode, setCustomSKUCode] = React.useState("");
  const [getNoOFVariant, setNoOFVariant] = React.useState("");
  const [getSupplierID, setSupplierID] = React.useState(0);
  const [getSupplierCode, setSupplierCode] = React.useState("");
  const [getSupplierPrice, setSupplierPrice] = React.useState("");
  const [getIsProdInventory, setIsProdInventory] = React.useState(false);
  const [getOutletInventoryAndTax, setOutletInventoryAndTax] = React.useState(
    []
  );
  const [getCompositeProductsData, setCompositeProductsData] = React.useState(
    []
  );
  const [getMarkupInPercentage, setMarkupInPercentage] = React.useState("");
  const [getRetailPrice, setRetailPrice] = React.useState("");
  const [getIsCustomLoyalty, setIsCustomLoyalty] = React.useState(false);
  const [getName, setName] = React.useState("");
  const [getLoyaltyPrice, setLoyaltyPrice] = React.useState("");
  const [getVariantName, setVariantName] = React.useState("");
  const [getSupplierName, setSupplierName] = React.useState("");
  const [getIsVariant, setIsVariant] = React.useState(false);
  const [getProductVariants, setProductVariants] = React.useState([]);
  const [getVariantAttributes, setVariantAttributes] = React.useState([]);
  const [getProductID, setProductID] = React.useState("");
  const [getURL, setURL] = React.useState("");
  const [getDefaultDecimalPlaces, setDefaultDecimalPlace] = React.useState(2); //api me isko db sy update rakhna hy

  //const [getDefaultOut, setDefaultOut] = React.useState('Select Outlet');
  //const [getDefaultCus, setDefaultCus] = React.useState('');

  React.useEffect(() => {
    let url = window.location.href.split("productdetail/");
    let id = url.length > 1 ? url[1] : false;
    if (id) {
      setProductID(id);
      getProductsData(id);
    } else {
      setSpinningLoading(false);
      message.info("No Details Available, Kindly Try Again...");
    }
  }, []);

  async function getProductsData(id) {
    const getProductData = ds.getProdDetailService({ ProductID: id });
    await getProductData
      .then((res) => {
        setSpinningLoading(false);
        if (res && res.productDetails) {
          let productCommonData = res.productDetails;
          setProdName(productCommonData.productName);
          if (
            productCommonData.productImages &&
            productCommonData.productImages.length > 0
          ) {
            setURL(productCommonData.productImages[0].imageURL);
          }
          let desc = productCommonData.description
            ? productCommonData.description.replace(/(<([^>]+)>)/gi, "")
            : "";
          setProdDesc(desc ? desc : "");
          setBrandName(productCommonData.brandName);
          let productTagObj =
            productCommonData.productTags &&
            productCommonData.productTags.length &&
            productCommonData.productTags.map((e) => {
              return { id: e.key, name: e.name };
            });
          if (productTagObj.length != 0) {
            setProdTags(productTagObj);
          }
          setProdInventType(productCommonData.productInventoryType);
          setIsCustomSKU(true);
          setCustomSKUCode(productCommonData.customSKUCode);
          setSupplierID(
            productCommonData.supplierID ? productCommonData.supplierID : 0
          );
          setNoOFVariant(productCommonData.noOfVariants);
          setSupplierCode(productCommonData.supplierCode);
          setSupplierPrice(productCommonData.supplyPrice);
          setIsProdInventory(productCommonData.isProductInventory);
          setOutletInventoryAndTax(productCommonData.outletInventoriesandTax);
          setCompositeProductsData(productCommonData.compositeProductsData);
          setMarkupInPercentage(productCommonData.markupInPercentage);
          setRetailPrice(productCommonData.retailPrice);
          setIsCustomLoyalty(productCommonData.isCustomLoyalty);
          setName(productCommonData.name);
          setLoyaltyPrice(productCommonData.loyaltyPrice);
          setVariantName(productCommonData.variantName);
          setIsVariant(productCommonData.isVariant);
          setProductVariants(productCommonData.productVariants);
          setVariantAttributes(productCommonData.variantAttributes);

          if (productCommonData.productInventoryType != "Standard Product") {
            ds.getProductOtherDetailByProductID(
              {
                productID: id,
                isThumbnailImage: false,
              },
              BEHAVIOUR_TYPE.GET
            ).then((res1) => {
              if (res1.data.msgCode == "GENERAL_SUCCESS") {
                if (res1.data.data.productDetails != null) {
                  let productOtherData = res1.data.data.productDetails;

                  if (
                    productOtherData.productInventoryType == "Composite Product"
                  ) {
                    if (
                      productOtherData.compositeProductsData != null &&
                      productOtherData.compositeProductsData.length > 0
                    ) {
                      setCompositeProductsData(
                        productOtherData.compositeProductsData
                      );
                    }
                  }
                  if (
                    productOtherData.productInventoryType ==
                    "Product with Variants"
                  ) {
                    if (
                      productOtherData.productVariants != null &&
                      productOtherData.productVariants.length > 0 &&
                      productOtherData.variantAttributes != null &&
                      productOtherData.variantAttributes.length > 0
                    ) {
                      setProductVariants(productOtherData.productVariants);
                      setVariantAttributes(productOtherData.variantAttributes);
                    }
                  }
                }
              }
            });
          }
        } else {
          message.info("Details not available...");
        }
      })
      .catch((e) => {
        notAllowMsgCheck(e);
        setSpinningLoading(false);
      });
  }

  const columns = [
    {
      title: <IntlMessages id="products.productdetail.out" />,
      dataIndex: "outletName",
      key: "outletName",
      render: (text, record) => {
        return (
          <span
            // onClick={() =>
            //   history.push(
            //     `/dashboard/products/pricebook/productdetail/${record.prodid}`
            //   )
            // }
            className=""
            style={{ fontWeight: "500" }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: <IntlMessages id="products.productdetail.instock" />,
      dataIndex: "currentInventory",
      key: "currentInventory",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
  ];

  const columnsComposite = [
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
      render: (text, record) => {
       
          let productID = record.productID;
          let productName = record.productName;
          if(record.isVariant){
            productID = getEncryptedID(record.parentProductID);
            productName = `${record.productName} ${record.variantName}`
          }
        return (
          <a
            href={`/dashboard/products/main/productdetail/${productID}`}
            className="gx-link"
            style={{ fontWeight: "500" }}
          >
            {productName}
          </a>
        );
      },
    },
    {
      title: "Supply Price",
      dataIndex: "supplyPrice",
      key: "supplyPrice",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
  ];

  const columnsProdVariants = [
    {
      title: "Variant Name",
      dataIndex: "variantName",
      key: "variantName",
      render: (text, record) => {
        return (
          <span className="" style={{ fontWeight: "500" }}>
            {text}
          </span>
        );
      },
    },
    {
      title: "SKU",
      dataIndex: "customSKUCode",
      key: "customSKUCode",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
    {
      title: "Supplier Name",
      dataIndex: "supplierName",
      key: "supplierName",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
    {
      title: "Supplier Code",
      dataIndex: "supplierCode",
      key: "supplierCode",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
    {
      title: "Supply Price",
      dataIndex: "supplyPrice",
      key: "supplyPrice",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{text}</span>;
      },
    },
    {
      title: "Retail Price",
      dataIndex: "retailPrice",
      key: "retailPrice",
      render: (text) => {
        return <span style={{ fontWeight: "500" }}>{parseFloat(text).toFixed(getDefaultDecimalPlaces)}</span>;
      },
    },
  ];

  return (
    <div className="Content-wrapper ProductDetails-pg">
     
      <Spin
        tip={<IntlMessages id="products.productdetail.loader" />}
        spinning={isSpinningLoading}
        size="large"
      >


        <Row className="back-arrow-h1 align-items-center justify-content-center mb-1 Product-header">
        <Col lg={6} md={6} sm={24} xs={24}>
        <h1 className="d-flex align-items-center">
            <ArrowLeftOutlined
              className="dk-vertical-align"
              onClick={() => history.goBack()}
            />
            <span className="mx-2">
            {" "}
            {getProdName}
            </span>
          </h1>
          </Col>
          <Col lg={18} md={18} sm={24} xs={24} className='text-right'>
          <div className="mt-10-md stockControll-btn">
                <Button
                  className=""
                  type="primary"
                  onClick={() =>
                    getProductID
                      ? history.push(
                          `/Dashboard/products/main/edit/${getProductID}`
                        )
                      : history.goBack()
                  }
                >
                  <IntlMessages id="products.main.add.editproduct" />
                </Button>
                <Button
                  className="dk-btn-add"
                  type="primary"
                  onClick={() =>
                    getProductID
                      ? history.push(
                          `/Dashboard/products/main/edit/${getProductID}`
                        )
                      : history.goBack()
                  }
                >
                  <IntlMessages id="products.main.add.addvariant" />
                </Button>
                <Button
                  className=""
                  type="primary"
                  onClick={() =>
                    getProductID
                      ? history.push(
                          `/Dashboard/products/main/duplicate/${getProductID}`
                        )
                      : history.goBack()
                  }
                >
                  <IntlMessages id="products.promotionlisting.duplicate" />
                </Button>
                {/* <Button
                  className="dk-btn-cancel"
                  type="primary"
                  onClick={() => message.warn("Cannot delete for now!")}
                >
                  <IntlMessages id="products.productypes.delete" />
                </Button> */}
              </div>
          </Col>
          </Row>

        <Card
          className="gx-card No-BoxShadow card-padd"
          title={
            <>
              
            </>
          }
          
        >
          <Row>
            <Col md={24}>
              {getProdTags.map((e, key) => {
                return (
                  e.name && (
                    <Tag key={key} color="blue">
                      {e.name}
                    </Tag>
                  )
                );
              })}
            </Col>
          </Row>

          <Divider />

          <Row className="mt-4">
            <Col span={9}>
              {getProdName && (
                <>
                  <h3 className="mb-0">
                    <IntlMessages id="prod.detail.handle" />
                  </h3>
                  <p className="mb-4">{getProdName}</p>
                </>
              )}

              {getSupplierName && (
                <>
                  <h3 className="mb-0">
                    <IntlMessages id="products.main.add.supplier" />
                  </h3>
                  <p className="mb-4">{getSupplierName}</p>
                </>
              )}

              {getBrandName && (
                <>
                  <h3 className="mb-0">
                    <IntlMessages id="products.main.add.brand" />
                  </h3>
                  <p className="mb-4">{getBrandName}</p>
                </>
              )}

              {getRetailPrice && (
                <>
                  <h3 className="mb-0">
                    <IntlMessages id="prod.detail.avgcost" />
                  </h3>
                  <p className="mb-4">{ getRetailPrice  ? parseFloat(getRetailPrice).toFixed(getDefaultDecimalPlaces)  : ""}</p>
                </>
              )}


              {getCustomSKUCode && getCustomSKUCode != "0" && (
                <>
                  <h2 className="mb-0">SKU</h2>
                  <p className="mb-4">{getCustomSKUCode}</p>
                </>
              )}
            </Col>
            <Col span={9}>
              {getSupplierPrice && (
                <>
                  <h3 className="mb-0">
                    <IntlMessages id="products.addeditpriceprod.supplyprice" />
                  </h3>
                  <p className="mb-4">{getSupplierPrice}</p>
                </>
              )}

              {getSupplierCode && (
                <>
                  <h3 className="mb-0">
                    <IntlMessages id="products.main.add.suppliercode" />
                  </h3>
                  <p className="mb-4">{getSupplierCode}</p>
                </>
              )}

              {getProdInventType && (
                <>
                  <h3 className="mb-0">
                    <IntlMessages id="prod.detail.invtype" />
                  </h3>
                  <p className="mb-4">{getProdInventType}</p>
                </>
              )}

              {getNoOFVariant && getNoOFVariant != "0" && (
                <>
                  <h3 className="mb-0">
                    <IntlMessages id="prod.detail.nbrofvar" />
                  </h3>
                  <p className="mb-4">{getNoOFVariant}</p>
                </>
              )}
            </Col>
            <Col span={6}>
              <div className="gx-featured-thumb prod-img">
                <img
                  className="gx-rounded-lg"
                  src={getURL ? getURL : ProductImg}
                  alt="..."
                />
              </div>
            </Col>
          </Row>
        </Card>

        {getOutletInventoryAndTax && getOutletInventoryAndTax.length > 0 && (
          <Card className="gx-card No-BoxShadow card-padd inventory-box"
            title="INVENTORY">
            <Table
              className="gx-table-responsive"
              columns={columns}
              dataSource={getOutletInventoryAndTax}
            />
          </Card>
        )}

        {getProductVariants && getProductVariants.length > 0 && (
          <Card className="gx-card No-BoxShadow card-padd inventory-box" title="VARIANTS">
            <Table
              className="gx-table-responsive"
              columns={columnsProdVariants}
              dataSource={getProductVariants}
            />
          </Card>
        )}

        {getCompositeProductsData && getCompositeProductsData.length > 0 && (
          <Card
            className="gx-card"
            title="COMPOSITE PRODUCT INFORMATION">
            <Table
              className="gx-table-responsive"
              columns={columnsComposite}
              dataSource={getCompositeProductsData}
            />
          </Card>
        )}

          <>
            <div className="mb-3">
              <h2 className="custom-font-weight-500 custom-font-color-black mb-0"> Product History </h2>

              <p className="custom-font-weight-500 custom-font-color-black small" >
                <i>
                  Looking for inventory movements ? Try the{" "}
                  <a
                    className="gx-link"
                    onClick={() => {
                      history.push(
                        `/dashboard/reporting/product-movements/${getProductID}`
                      );
                    }}
                  >
                    {" "}
                    Inventory Movements view.
                  </a>{" "}
                </i>
              </p>
            </div>
            {!StringIsNullOrEmpty(getProductID) ? (
              <InventoryMovementListing
                productID={getProductID}
                isComponent={true}
                pageSize={5}
              />
            ) : (
              ""
            )}
          </>
  
      </Spin>
    </div>
  );
};

export default ProductDetail;
